import {
  IconButton,
  Avatar,
  Box,
  CloseButton,
  Flex,
  HStack,
  VStack,
  Icon,
  useColorModeValue,
  Text,
  Drawer,
  DrawerContent,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Image,
  Button
} from '@chakra-ui/react'
import {
  FiHome,
  FiTrendingUp,
  FiStar,
  FiMenu,
  FiDollarSign,
  FiChevronDown,
  FiChevronsUp, 
  FiZap,
  FiServer,
  FiGift
} from 'react-icons/fi'
import { IoPricetagOutline } from "react-icons/io5";
import { MdOutlineSupportAgent } from "react-icons/md";
import { GiRabbit } from "react-icons/gi";

import { Link } from 'react-router-dom';


const LinkItems = [
  { name: 'Overview', icon: FiHome, link: "/overview", isHighlight: false },
  { name: 'Usage', icon: FiTrendingUp, link: "/api_usage", isHighlight: false },
  { name: 'RPC', icon: FiServer, link: "/rpc", isHighlight: false },
  { name: 'gRPC', icon: FiZap, link: "/grpc", isHighlight: false },
  { name: 'RabbitStream', icon: GiRabbit, link: "/rabbitstream", isHighlight: true },
  { name: 'Dedicated Nodes', icon: FiChevronsUp, link: "/dedicated-nodes", isHighlight: false },
  { name: 'Referrals', icon: FiGift, link: "/referrals", isHighlight: false },
  { name: 'Pricing', icon: IoPricetagOutline, link: "/pricing", isHighlight: false },
  { name: 'Billing', icon: FiDollarSign, link: "/billings", isHighlight: false },
  
  { name: "SPACER", icon: null, link: null, type: "SPACER" },
  { name: 'Resources', icon: FiStar, link: "/resources" },
  // { name: 'Support', icon: MdOutlineSupportAgent, function: "/dashboard/support", type: "BUTTON" }
]

const SidebarContent = ({ onClose,path,displaySupportTextforSecs, ...rest }) => {
  return (
    <Box
      transition="3s ease"
      bg={useColorModeValue('black', 'black')}
      borderRight="1px"
      borderRightColor={useColorModeValue('brand.lightGrey', 'brand.lightGrey')}
      w={{ base: 'full', md: 60, lg: "280px" }}
      pos="fixed"
      h="full"
      overflow={"auto"}
      paddingBottom={"40px"}
      {...rest}>
      <Flex h="20" alignItems="center" mx="14" justifyContent="space-between">
        <Box as='a' href='https://shyft.to'>
            <Image src={"/shyft_logo.svg"} w={"92px"} alt='Shyft logo'/>
        </Box>
        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} color={"brand.white"}/>
      </Flex>
      <Box h={"20px"}>

      </Box>
      {LinkItems.map((link) => {
        if(link.name === "SPACER"){
          return (
            <Box className='spacer_height' key={link.name}>

            </Box>
          )
        }
        return (
        <NavItem key={link.name} icon={link.icon} link={link.link} path={path} isHighlight={link.isHighlight}>
          {link.name}
        </NavItem>
      )})}
      <NavButton displaySupportTextforSecs={displaySupportTextforSecs} key={"button"} icon={MdOutlineSupportAgent}>
        Support
      </NavButton>
      {/* <Button onClick={() => displaySupportTextforSecs(2)}>test</Button> */}
    </Box>
  )
}

const NavItem = ({ icon, children, link, isHighlight, path, ...rest }) => {
  const trailLink = link.substring(link.lastIndexOf('/') + 1);
  const trailPath = path.substring(path.lastIndexOf('/') + 1);

  return (
    <Box
      fontSize={{base: "md", lg: "lg"}}
      fontFamily={"heading"}
      fontWeight={"500"}
      style={{ textDecoration: 'none' }}
      _focus={{ boxShadow: 'none' }}>
      <Link to={link}>
        <Flex
          className={isHighlight?"highlight_box":""}
          align="center"
          px="4"
          py={{base: "12px", xl: "14px"}}
          mx="10"
          borderRadius="lg"
          role="group"
          cursor="pointer"
          color={(trailLink.toLowerCase() === trailPath.toLowerCase())?"brand.yellow":"brand.white"}
          _hover={{
            bg: 'brand.red',
            color: 'white',
          }}
          {...rest}>
          {icon && (
            <Icon
              mr="4"
              fontSize="16"
              color={(trailLink.toLowerCase() === trailPath.toLowerCase())?"brand.red":"brand.white"}
              _groupHover={{
                color: 'white',
              }}
              as={icon}
            />
          )}
          <Text as={"div"} fontSize={{base: "14px", md: "18px", xl: "18px"}}>{children}</Text>
        </Flex>
      </Link>
    </Box>
  )
}
const NavButton = ({ icon, children, link, path,displaySupportTextforSecs, ...rest }) => {
  return (
    // <Box
    //   fontSize={{base: "md", lg: "lg"}}
    //   fontFamily={"heading"}
    //   fontWeight={"500"}
    //   style={{ textDecoration: 'none' }}
    //   _focus={{ boxShadow: 'none' }}>
      <Button onClick={() => displaySupportTextforSecs(2)} bg={"transparent"} _hover={{bg: "brand.red"}} w={"200px"} marginLeft={"40px"} paddingLeft={"22px"} paddingY={"28px"}>
        <Flex
          align="center"
          px="0px"
          py={{base: "12px", xl: "14px"}}
          mx="10"
          borderRadius="lg"
          role="group"
          cursor="pointer"
          color={"brand.white"}
          
          fontSize={{base: "14px", md: "18px", xl: "18px"}}
          fontFamily={"heading"}
      fontWeight={"500"}
          {...rest}>
          {icon && (
            <Icon
              mr="4"
              fontSize="16"
              color={"brand.white"}
              _groupHover={{
                color: 'white',
              }}
              as={icon}
            />
          )}
          {children}
          <Box w={"74px"} height={"20px"}></Box>
        </Flex>
      </Button>
    // </Box>
  )
}

const MobileNav = ({ onOpen,email,logout,name,apKey, ...rest }) => {
  return (
    <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      height="20"
      alignItems="center"
      bg={useColorModeValue('black', 'black')}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('brand.lightGrey', 'brand.lightGrey')}
      justifyContent={{ base: 'space-between', md: 'flex-end' }}
      {...rest}>
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
        color={"brand.white"}
        _hover={{
          bg: "transparent"
        }}
      />

      {/* <Text
        display={{ base: 'flex', md: 'none' }}
        fontSize="2xl"
        fontFamily="monospace"
        fontWeight="bold">
        Logo
      </Text> */}
      <Box 
        display={{ base: 'flex', md: 'none' }}
        as='a'
        href='https://shyft.to'
      >
            <Image src={"/shyft_logo.svg"} w={"90px"} alt='Shyft logo'/>
      </Box>

      <HStack spacing={{ base: '0', md: '6' }}>
        {/* <IconButton size="lg" variant="ghost" aria-label="open menu" icon={<FiBell />} /> */}
        <Flex alignItems={'center'}>
          <Menu>
            <MenuButton py={2} transition="all 0.3s" _focus={{ boxShadow: 'none' }}>
              <HStack>
                <Avatar
                  size={'sm'}
                  name={email}
                  src={
                    ''
                  }
                />
                <VStack
                  display={{ base: 'none', md: 'flex' }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2">
                  <Text as={"div"} fontSize="sm" color={useColorModeValue("brand.white","brand.white")}>{(name !== '')?name:email}</Text>
                  <Text as={"div"} fontSize="xs" color="brand.midGrey">
                    {(name !== '')?email:apKey}
                  </Text>
                </VStack>
                <Box display={{ base: 'none', md: 'flex' }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              bg={useColorModeValue('white', 'gray.900')}
              borderColor={useColorModeValue('gray.200', 'gray.700')}>
              {/* <MenuItem>Profile</MenuItem>
              <MenuItem>Settings</MenuItem>
              <MenuItem>Billing</MenuItem>
              <MenuDivider /> */}
              <MenuItem onClick={logout}>Sign out</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  )
}

const SidebarWithHeader = ({ children,path,email,name,apKey,logout,displaySupportTextforSecs }) => {
  // const router = useRouter();
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box minH="100vh" bg={useColorModeValue('brand.black', 'brand.black')} paddingTop={{base: "60px", lg: "30px"}}>
      <SidebarContent path={path} onClose={() => onClose} display={{ base: 'none', md: 'block' }} displaySupportTextforSecs={displaySupportTextforSecs} />
      
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size={{base: "xs", md: "full"}}>
        <DrawerContent>
          <SidebarContent path={path} onClose={onClose} displaySupportTextforSecs={displaySupportTextforSecs}/>
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}
      <MobileNav onOpen={onOpen} email={email} name={name} apKey={apKey} logout={logout} />
      <Box ml={{ base: 0, md: 60, lg: "280px" }} p="4">
        {children}
      </Box>
    </Box>
  )
}

export default SidebarWithHeader